import {
  Button,
  Icon,
  IconButton,
  Modal,
  Paper,
  Typography,
} from "@mui/material";

import useStyles from "./styles";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { Box } from "@mui/system";
import { Close } from "@mui/icons-material";
export default function ModalConfig({
  hostSelector,
  onuSelector,
  linkSelector,
  sessaoSelector,
  editMode,
  setEditMode,
  handleSave,
  handleCancel,
  disableSave = false,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Modal
      open={editMode}
      onClose={() => {
        setEditMode(false);
        handleCancel();
      }}
    >
      <Paper sx={styles.modal}>
        <Box sx={styles.header}>
          <Typography sx={styles.title}>Configurações</Typography>
          <IconButton
            onClick={() => {
              setEditMode(false);
              handleCancel();
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <Paper
          variant={theme.palette.mode === "light" && "outlined"}
          sx={styles.paperInternal}
        >
          {hostSelector}
          {onuSelector}
          {linkSelector}
          {sessaoSelector}
        </Paper>
        <Box sx={styles.containerButton}>
          <Button
            variant="outlined"
            onClick={() => {
              setEditMode(false);
              handleCancel();
            }}
          >
            Cancelar
          </Button>
          <Button variant="contained" disabled={disableSave} onClick={() => handleSave()}>
            Salvar
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
}
